// removed by extract-text-webpack-plugin
module.exports = {"root":"_N1S1u","children":"_1lFUy","arrowIcon":"_2OXpL"};


//////////////////
// WEBPACK FOOTER
// ./app/components/PageListHeader/components/DragScroll/DragScroll.scss
// module id = 876
// module chunks = 9